<template>
  <div class="is-flex">
    <select @change="onChange($event)" v-model="opcaoSelecionada">
      <option
        v-for="(option, index) in this.opcoesSelect"
        :key="index"
        :value="option.label"
        :disabled="option.hidden"
      >
        {{ option.label }}
      </option>
    </select>
    <button class="clear-button" @click="limparOpcaoSelecionada">
      <i class="mdi mdi-window-close"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "TrfChooserSimplesComValidacaoDeItemSelecionado",
  emits: ['change'],
  props: {
    placeholder: String,
    opcoesCabecalhosSelect: Object,
    valueOpcoes: Object,
  },
  data() {
    return {
      valorJaSelecionadoNoSelect: "",
      isVisible: false,
      teste: null,
      opcoesSelect: this.opcoesCabecalhosSelect,
      opcaoSelecionada: "",
    };
  },
  methods: {
    limparOpcaoSelecionada(){
      this.atualizarHiddenDaOpcao(this.opcaoSelecionada, false);
      this.opcaoSelecionada = '';
    },
    onChange(event) {
      const valor = event ? event.target.value : null;

      if (this.valorJaSelecionadoNoSelect) {
        this.atualizarHiddenDaOpcao(this.valorJaSelecionadoNoSelect, false);
        this.valorJaSelecionadoNoSelect = null;
      }

      if (valor) {
        if (valor != "Ignorar coluna") {
          this.atualizarHiddenDaOpcao(valor, true);
        }
        const indexOpcao = this.buscarIndiceOpcao(valor);
        const objetoDovalorJaSelecionadoNoSelect = this.opcoesSelect[indexOpcao];
        this.valorJaSelecionadoNoSelect = objetoDovalorJaSelecionadoNoSelect.label;
        this.atualizarRequiredDaOpcao(objetoDovalorJaSelecionadoNoSelect.value);
        this.opcaoSelecionada = this.opcoesSelect[indexOpcao].label;
        
        this.$emit("change", valor);
      }

      this.opcoesSelect = [...this.opcoesSelect];
    },

    atualizarHiddenDaOpcao(valorOpcao, hidden) {
      const indexOpcao = this.buscarIndiceOpcao(valorOpcao);
      this.opcoesSelect[indexOpcao].hidden = hidden;
    },

    buscarIndiceOpcao(valorOpcao) {
      return this.opcoesSelect.findIndex((opcao) => opcao.label == valorOpcao);
    },

    atualizarRequiredDaOpcao(itemDeDependencia) {
      if (itemDeDependencia == this.valueOpcoes.Vinculacao) {
        let dadosDoItemDeDependencia = this.bucarDadosDoItemDeDependencia(itemDeDependencia);
        dadosDoItemDeDependencia.required = !dadosDoItemDeDependencia.required;
      }
    },

    bucarDadosDoItemDeDependencia(itemDeDependencia) {
      return this.opcoesSelect.find((opcao) => {
        return opcao.value == itemDeDependencia;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.clear-button {
  background-color: transparent;
  border: none;
}
</style>
